import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import formatISODate from '../../../Helpers/formatISODate'
import { TRACKING_STATUS } from '../../../constants'
import './styles.scss'

const getStatusConfig = (status) => {
  switch (status) {
    case TRACKING_STATUS.Delivered:
      return { color: '#22c55e', bg: 'rgba(34,197,94,0.1)', icon: solid('circle-check') }
    case TRACKING_STATUS.Active:
    case TRACKING_STATUS['Picked Up']:
    case TRACKING_STATUS.Arrived:
      return { color: '#c05228', bg: 'rgba(192,82,40,0.1)', icon: solid('truck') }
    case TRACKING_STATUS['On hold']:
    case TRACKING_STATUS.Inactive:
      return { color: '#9ca3af', bg: 'rgba(156,163,175,0.1)', icon: solid('circle-pause') }
    default:
      return { color: '#ef4444', bg: 'rgba(239,68,68,0.1)', icon: solid('triangle-exclamation') }
  }
}

const InfoRow = ({ label, value }) => (
  <div className="info-row">
    <span className="info-row__label">{label}</span>
    <span className="info-row__value">{value || '—'}</span>
  </div>
)

const TrackItResult = ({ trackItResult, onReset }) => {
  const statusConfig = getStatusConfig(trackItResult.status)
  const dispatchDate = formatISODate(trackItResult.dispatchDate)?.split(' ')[0]
  const eta = formatISODate(trackItResult.estimatedDeliveryDate)?.split(' ')[0]

  return (
    <div className="track-result">

      <div className="track-result__status-wrap">
        <div
          className="track-result__status-badge"
          style={{
            color: statusConfig.color,
            backgroundColor: statusConfig.bg,
            borderColor: statusConfig.color,
          }}
        >
          <FontAwesomeIcon icon={statusConfig.icon} />
          <span>{trackItResult.status}</span>
        </div>
      </div>

      <div className="track-result__summary">
        <div className="summary__tracking">
          <span className="summary__label">Tracking Number</span>
          <span className="summary__number">{trackItResult.trackingNumber}</span>
        </div>

        <div className="summary__route">
          <div className="summary__location">
            <FontAwesomeIcon className="summary__dot summary__dot--origin" icon={solid('circle-dot')} />
            <div>
              <span className="summary__loc-label">Origin</span>
              <span className="summary__loc-value">{trackItResult.dispatchLocation || '—'}</span>
            </div>
          </div>

          <div className="summary__connector">
            <div className="summary__line" />
            <FontAwesomeIcon className="summary__arrow" icon={solid('plane-up')} />
            <div className="summary__line" />
          </div>

          <div className="summary__location summary__location--right">
            <FontAwesomeIcon className="summary__dot summary__dot--dest" icon={solid('location-dot')} />
            <div>
              <span className="summary__loc-label">Destination</span>
              <span className="summary__loc-value">{trackItResult.receiverAddress || '—'}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="track-result__parties">
        <div className="party-card">
          <div className="party-card__header">
            <FontAwesomeIcon icon={solid('user')} />
            <span>Shipper / Sender</span>
          </div>
          <InfoRow label="Name" value={trackItResult.senderName} />
          <InfoRow label="Address" value={trackItResult.senderAddress} />
        </div>

        <div className="party-card">
          <div className="party-card__header">
            <FontAwesomeIcon icon={solid('user-check')} />
            <span>Consignee / Receiver</span>
          </div>
          <InfoRow label="Name" value={trackItResult.receiverName} />
          <InfoRow label="Address" value={trackItResult.receiverAddress} />
        </div>
      </div>

      <div className="track-result__details">
        <h4 className="track-result__section-label">Shipment Details</h4>
        <div className="details-grid">
          <div className="detail-item">
            <FontAwesomeIcon className="detail-item__icon" icon={solid('calendar')} />
            <div>
              <span className="detail-item__label">Dispatch Date</span>
              <span className="detail-item__value">{dispatchDate || '—'}</span>
            </div>
          </div>

          <div className="detail-item">
            <FontAwesomeIcon className="detail-item__icon" icon={solid('calendar-check')} />
            <div>
              <span className="detail-item__label">Est. Delivery</span>
              <span className="detail-item__value">{eta || '—'}</span>
            </div>
          </div>

          <div className="detail-item">
            <FontAwesomeIcon className="detail-item__icon" icon={solid('location-dot')} />
            <div>
              <span className="detail-item__label">Current Location</span>
              <span className="detail-item__value">{trackItResult.currentLocation || '—'}</span>
            </div>
          </div>

          <div className="detail-item">
            <FontAwesomeIcon className="detail-item__icon" icon={solid('box')} />
            <div>
              <span className="detail-item__label">Package Description</span>
              <span className="detail-item__value">{trackItResult.packageDescription || '—'}</span>
            </div>
          </div>
        </div>
      </div>

      <button className="track-result__reset" onClick={onReset}>
        <FontAwesomeIcon icon={solid('rotate-left')} />
        Track Another Shipment
      </button>

    </div>
  )
}

export default TrackItResult
